/**
 * Mapeia nomes de ícones Material Symbols (ligature / snake_case) → nome kebab-case do Lucide (DynamicIcon).
 * Mantido explícito para evitar nomes errados e garantir bundle por ícone via dynamic imports.
 */
export const materialToLucide = {
  access_time: 'clock',
  account_balance_wallet: 'wallet',
  account_circle: 'circle-user',
  add: 'plus',
  add_business: 'building-2',
  add_circle: 'circle-plus',
  add_comment: 'message-square-plus',
  add_location: 'map-pin-plus',
  add_location_alt: 'map-pin-plus',
  add_photo_alternate: 'image-plus',
  add_shopping_cart: 'shopping-cart',
  admin_panel_settings: 'user-cog',
  analytics: 'line-chart',
  archive: 'archive',
  arrow_back: 'arrow-left',
  arrow_downward: 'arrow-down',
  arrow_forward: 'arrow-right',
  assignment: 'clipboard-list',
  assignment_turned_in: 'clipboard-check',
  attach_file: 'paperclip',
  auto_awesome: 'sparkles',
  badge: 'badge',
  block: 'ban',
  bolt: 'zap',
  business: 'building-2',
  calendar_month: 'calendar-days',
  calendar_today: 'calendar',
  calendar_view_month: 'calendar-range',
  calendar_view_week: 'calendar-range',
  call: 'phone-call',
  camera_alt: 'camera',
  campaign: 'megaphone',
  cancel: 'circle-x',
  category: 'tags',
  chat: 'messages-square',
  chat_bubble: 'message-circle',
  chat_bubble_outline: 'message-circle',
  check: 'check',
  check_circle: 'circle-check',
  checklist: 'list-checks',
  chevron_left: 'chevron-left',
  chevron_right: 'chevron-right',
  close: 'x',
  cloud_upload: 'cloud-upload',
  collections: 'images',
  comment: 'message-square',
  construction: 'construction',
  contact_info: 'id-card',
  contacts: 'contact',
  credit_card: 'credit-card',
  dashboard: 'layout-dashboard',
  dashboard_customize: 'layout-grid',
  delete: 'trash-2',
  delete_forever: 'trash-2',
  description: 'file-text',
  dns: 'server',
  done_all: 'check-check',
  download: 'download',
  drag_indicator: 'grip-vertical',
  drive_file_move: 'folder-input',
  edit: 'square-pen',
  edit_document: 'file-pen-line',
  edit_note: 'file-pen',
  email: 'mail',
  emoji_emotions: 'smile',
  error: 'circle-alert',
  event: 'calendar',
  event_add: 'calendar-plus',
  event_available: 'calendar-check',
  event_busy: 'calendar-x',
  event_note: 'calendar-clock',
  event_upcoming: 'calendar-clock',
  expand_more: 'chevron-down',
  expand_less: 'chevron-up',
  expand_more: 'chevron-down',
  extension: 'puzzle',
  facebook: 'facebook',
  fact_check: 'badge-check',
  flag: 'flag',
  folder: 'folder',
  folder_off: 'folder-x',
  forward: 'forward',
  fullscreen: 'maximize',
  gavel: 'gavel',
  group: 'users',
  group_add: 'user-plus',
  groups: 'users-round',
  headset_mic: 'headset',
  help: 'circle-help',
  history: 'history',
  hourglass_empty: 'hourglass',
  hourglass_top: 'hourglass',
  hub: 'network',
  image: 'image',
  inbox: 'inbox',
  info: 'info',
  inventory: 'package',
  inventory_2: 'package',
  key: 'key',
  label: 'tag',
  label_off: 'bookmark-x',
  language: 'languages',
  lightbulb: 'lightbulb',
  link: 'link',
  link_off: 'link-2-off',
  list: 'list',
  local_fire_department: 'flame',
  local_offer: 'tag',
  local_shipping: 'truck',
  location_off: 'map-pin-off',
  location_on: 'map-pin',
  lock: 'lock',
  lock_reset: 'key-round',
  login: 'log-in',
  logout: 'log-out',
  mail: 'mail',
  map: 'map',
  menu: 'menu',
  message: 'message-square',
  mic: 'mic',
  monetization_on: 'coins',
  monitoring: 'activity',
  mood: 'smile',
  more_horiz: 'ellipsis',
  more_vert: 'ellipsis-vertical',
  new_label: 'tag',
  note: 'sticky-note',
  notes: 'notebook-text',
  notifications: 'bell',
  notifications_active: 'bell-ring',
  open_in_new: 'external-link',
  palette: 'palette',
  pause: 'pause',
  payment: 'banknote',
  payments: 'banknote',
  people: 'users',
  percent: 'percent',
  person: 'user',
  person_add: 'user-plus',
  person_off: 'user-x',
  person_remove: 'user-minus',
  person_search: 'user-search',
  phone: 'phone',
  photo_camera: 'camera',
  play_arrow: 'play',
  power_settings_new: 'power',
  preview: 'eye',
  price_check: 'badge-dollar-sign',
  priority_high: 'alert-circle',
  progress_activity: 'loader-circle',
  qr_code: 'qr-code',
  qr_code_2: 'qr-code',
  rate_review: 'message-square-text',
  receipt_long: 'receipt-text',
  refresh: 'refresh-cw',
  replay: 'rotate-ccw',
  restaurant: 'utensils',
  restaurant_menu: 'utensils-crossed',
  router: 'router',
  save: 'save',
  schedule: 'clock',
  schedule_send: 'send',
  search: 'search',
  search_off: 'search-x',
  send: 'send',
  settings: 'settings',
  shopping_bag: 'shopping-bag',
  shopping_cart: 'shopping-cart',
  smart_toy: 'bot',
  smartphone: 'smartphone',
  sort: 'arrow-up-down',
  source: 'database',
  south: 'arrow-down',
  speed: 'gauge',
  star: 'star',
  stars: 'sparkles',
  stop: 'square',
  stop_circle: 'circle-stop',
  store: 'store',
  subdirectory_arrow_right: 'corner-down-right',
  subject: 'align-left',
  summarize: 'list-collapse',
  support_agent: 'headset',
  swap_vert: 'arrow-up-down',
  sync: 'refresh-cw',
  sync_alt: 'refresh-ccw',
  table_restaurant: 'utensils-crossed',
  tag: 'tag',
  task: 'list-todo',
  task_alt: 'square-check',
  terminal: 'terminal',
  text_snippet: 'text-quote',
  timer: 'timer',
  today: 'calendar',
  toll: 'circle-dollar-sign',
  trending_up: 'trending-up',
  tune: 'sliders-horizontal',
  unfold_less: 'shrink',
  unfold_more: 'expand',
  update: 'refresh-cw',
  upgrade: 'arrow-big-up',
  upload: 'upload',
  upload_file: 'file-up',
  videocam: 'video',
  psychology: 'brain',
  alarm: 'alarm-clock',
  view_agenda: 'layout-list',
  view_day: 'calendar',
  view_kanban: 'columns-3',
  view_week: 'calendar-range',
  visibility: 'eye',
  vpn_key: 'key-round',
  warehouse: 'warehouse',
  warning: 'triangle-alert',
  waving_hand: 'hand',
  wifi: 'wifi',
  work: 'briefcase',
  workspace_premium: 'crown',
  workspaces: 'panels-top-left',
};
